"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.klass = exports.addClassNames = void 0;
var klass = exports.klass = function klass(blockClass) {
  return function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    return names.filter(Boolean).map(function (name) {
      return "".concat(blockClass, "__").concat(name);
    }).join(' ');
  };
};
var addClassNames = exports.addClassNames = function addClassNames() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return args.filter(Boolean).join(' ');
};
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');